import { createAction, handleActions } from 'redux-actions';

import { Map, fromJS } from 'immutable';
import { pender } from 'redux-pender';
import axios from 'axios';

import * as userLib from 'libs/userLib';
import * as normal from 'libs/normalizer';

import { apiUrl } from 'libs/commonVar';

function logoutAPI() {
  return axios({
    method: 'get',
    url: apiUrl + 'Login/Logout',
    params: {}
  });
}

// action types
const INITIAL_STORE = 'user/INITIAL_STORE';
const CHANGE_PARAM = 'user/CHANGE_PARAM';
const CHANGE_USER = 'user/CHANGE_USER';
const RELOAD_USER = 'user/RELOAD_USER';
const GET_USER = 'user/GET_USER';
const UPDATE_USER = 'user/UPDATE_USER';
const DELETE_USER = 'user/DELETE_USER';
const ADD_USER = 'user/ADD_USER';
const SET_USER = 'user/SET_USER';
const LOGOUT = 'user/LOGOUT';
const CHANGE_EMAIL_RESEND = 'user/CHANGE_EMAIL_RESEND';
const CHANGE_EMAIL_CANCEL = 'user/CHANGE_EMAIL_CANCEL';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeParam = createAction(CHANGE_PARAM);
export const changeUser = createAction(CHANGE_USER);
export const reloadUser = createAction(RELOAD_USER);
export const getUser = createAction(GET_USER, userLib.getUser);
export const updateUser = createAction(UPDATE_USER, userLib.updateUser);
export const deleteUser = createAction(DELETE_USER, userLib.deleteUser);
export const addUser = createAction(ADD_USER, userLib.addUser);
export const setUser = createAction(SET_USER);
export const logout = createAction(LOGOUT, logoutAPI);
export const userChangeEmailReSend = createAction(CHANGE_EMAIL_RESEND, userLib.userChangeEmailReSend);
export const userChangeEmailCancel = createAction(CHANGE_EMAIL_CANCEL, userLib.userChangeEmailCancel);

// initial state
const initialState = fromJS({
  data: {
    result: -1,
    success: [],
    fail: []
  },
  indexByNo: {},
  needReload: false,
  user: null,
  // 0 - 로그인 안됨, 1 - 일반사용자, 2 - 관리자
  isAuth: 0,
  // 세션 종료 시간
  sessionTimeout: 0,
  param: Map({
    filter: Map({}),
    sort: [{ field: 'leakFileNo', order: 'DESC' }]
  }),
  totalPages: 0,
  totalCount: 0
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['param', name], value);
    },
    [CHANGE_USER]: (state, action) => {
      const { name, value } = action.payload;
      const user = state.get('user');

      user[name] = value;

      return state.set('user', user);
    },
    [RELOAD_USER]: (state, action) => {
      return state.set('needReload', true);
    },
    ...pender({
      type: GET_USER,
      onSuccess: (state, action) => {
        const { data } = action.payload;
        const { offset, limit } = action.payload.config.params;

        let userInfo = state.get('user');
        if (userInfo && Map.isMap(userInfo)) {
          userInfo = userInfo.toJS();
        }
        if (data && data.list && Array.isArray(data.list) && data.list.length === 1) {
          userInfo = Object.assign(userInfo || {}, data.list[0]);
        }

        // 전체 목록 수
        const totalCount = data.list.length > 0 ? data.list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);

        const stateObj = normal.payloadDataSaver(state, 'data', data);
        return stateObj
          .set('needReload', false)
          .set('totalPages', totalPages)
          .set('totalCount', totalCount)
          .set('indexByNo', fromJS(normal.listIndexByNo(data.list, 'userNo')))
          .set('user', userInfo);
      },
      onFailure: (state, action) => {
        console.log('GET_USER 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: UPDATE_USER,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        if (list) {
          const userData = { ...state.get('user'), ...list[0] };
          return state.set('user', userData).set('needReload', true);
        } else {
          return state;
        }

        // if (list) {
        //   if (list[0].serviceName) {
        //     userData.serviceName = list[0].serviceName;
        //     state = state.set('user', userData);
        //   }

        //   if (list[0].userNewEmail) {
        //     userData.userNewEmail = list[0].userNewEmail;
        //     state = state.set('user', userData);
        //   }

        //   if (list[0].userName) {
        //     userData.userName = list[0].userName;
        //     state = state.set('user', userData);
        //   }

        //   if (list[0].userPhone) {
        //     userData.userPhone = list[0].userPhone;
        //     state = state.set('user', userData);
        //   }
        // }

        // return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('UPDATE_USER 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: DELETE_USER,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('DELETE_USER 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: ADD_USER,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('ADD_USER 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    // 로그아웃
    ...pender({
      type: LOGOUT, // type 이 주어지면, 이 type 에 접미사를 붙인 액션핸들러들이 담긴 객체를 생성합니다.
      onSuccess: (state, action) => {
        return state.set('user', null).set('isAuth', 0);
      },
      onFailure: (state, action) => {
        return state.set('user', null).set('isAuth', 0);
      }
      // 함수가 생략됐을때 기본 값으론 (state, action) => state 가 설정됩니다 (state 를 그대로 반환한다는 것이죠)
    }),
    // 유저 설정
    [SET_USER]: (state, action) => {
      const { user, sessionTimeout } = action.payload;
      // isAdmin 처리 할것
      return state
        .set('user', user)
        .set('isAuth', user.isAdmin === 1 ? 2 : 1)
        .set('sessionTimeout', sessionTimeout);
    },
    ...pender({
      type: CHANGE_EMAIL_RESEND,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('CHANGE_EMAIL_RESEND 실패');
      }
    }),
    ...pender({
      type: CHANGE_EMAIL_CANCEL,
      onSuccess: (state, action) => {
        const userData = state.get('user');

        userData.userNewEmail = null;
        state = state.set('user', userData);

        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('CHANGE_EMAIL_CANCEL 실패');
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/user.js